import axiosApiClient from "../axios";

const PATH = '/api/room';

export const getAllRooms = async () => {
    try {
        return await axiosApiClient.get(PATH);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get all rooms');
    }
};

export const getAllRoomByBranchId = async (branchId) => {
    try {
        return await axiosApiClient.get(`${PATH}/branch/${branchId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get rooms by branch ID');
    }
};

export const getAllRoomById = async (id) => {
    try {
        return await axiosApiClient.get(`${PATH}/${id}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get room by ID');
    }
};

export const addRoom = async (room) => {
    try {
        return await axiosApiClient.post(PATH, room);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Add Room failed');
    }
};

export const deleteRoom = async (roomId) => {
    try {
        return await axiosApiClient.delete(`${PATH}/${roomId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Delete Room failed');
    }
};

export const updateRoom = async (roomId, room) => {
    try {
        return await axiosApiClient.put(`${PATH}/${roomId}`, room, {});
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Update Room failed');
    }
};

